import React from "react";
import PricingPlansDashboard from "../PricingPlansDashboard";

const SubscriptionUpgradeTab = ({
  organization,
  availablePlans,
  loadingPlans,
  handlePlanSelection,
  handleUpgradeClick,
  isLoading,
  formatPrice,
  onContactSale,
}) => {
  const canUpgrade = availablePlans?.length > 0;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-base font-semibold text-gray-900">Upgrade</h2>
        <p className="text-xs text-gray-500 mt-0.5">
          Upgrade your plan to unlock more features
        </p>
      </div>
      <div
        className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden"
        data-upgrade-section
      >
        <div className="p-6 sm:p-8">
          {organization?.planId === "FREE" ||
          organization?.planId === "FREE_IN" ? (
            <div>
              <div className="text-center mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Choose Your Plan
                </h3>
                <p className="text-gray-500 text-sm max-w-md mx-auto">
                  Upgrade from Free to select the perfect plan for your signing
                  needs.
                </p>
              </div>
              <PricingPlansDashboard
                isMinimal={true}
                showHeader={false}
                showBillingToggle={true}
                disableFreePlan={true}
                onPlanSelect={handlePlanSelection}
              />
            </div>
          ) : canUpgrade ? (
            <>
              <h3 className="text-base font-semibold text-gray-900 mb-6">
                Available Upgrades
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {loadingPlans ? (
                  <div className="flex items-center justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
                    <span className="ml-3 text-gray-600">
                      Loading upgrade options...
                    </span>
                  </div>
                ) : availablePlans?.length === 0 ? (
                  <div className="text-center py-8">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg
                        className="w-8 h-8 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                        />
                      </svg>
                    </div>
                    <p className="text-gray-600">
                      No upgrade plans available at the moment.
                    </p>
                  </div>
                ) : (
                  availablePlans.map((plan) => (
                    <div
                      key={plan._id}
                      className="rounded-xl border border-gray-200 bg-gray-50/50 p-6"
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <h4 className="text-xl font-bold text-gray-900 mb-2">
                            {plan.name}
                          </h4>
                          <p className="text-sm text-gray-600 mb-4">
                            {plan.description}
                          </p>
                          <div className="space-y-2">
                            {plan.features?.map((feature, idx) => (
                              <div
                                key={idx}
                                className="flex items-center text-sm text-gray-700"
                              >
                                <svg
                                  className="w-4 h-4 text-primary mr-2"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                {feature}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      {!plan.contact && (
                        <div className="flex items-center justify-between">
                          <div className="text-sm text-gray-600">
                            <span className="font-semibold">
                              {formatPrice(
                                plan,
                                organization?.subscriptionType
                              )}
                            </span>
                            /
                            {organization?.subscriptionType === "MONTHLY"
                              ? "month"
                              : "year"}{" "}
                            per user
                          </div>
                          <button
                            onClick={() =>
                              handleUpgradeClick(
                                plan,
                                organization?.subscriptionType?.toLowerCase() ||
                                  "monthly"
                              )
                            }
                            disabled={isLoading}
                            className={`px-6 py-3 rounded-lg text-sm font-bold focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all duration-300 shadow-lg ${
                              isLoading
                                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                                : "bg-primary text-white hover:bg-primary-dark"
                            }`}
                          >
                            <div className="flex items-center space-x-2">
                              {isLoading ? (
                                <>
                                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                                  <span>Upgrading...</span>
                                </>
                              ) : (
                                <>
                                  <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                                    />
                                  </svg>
                                  <span>Upgrade Now</span>
                                </>
                              )}
                            </div>
                          </button>
                        </div>
                      )}
                      {plan.contact && (
                        <div className="flex items-center justify-end">
                          <button
                            onClick={() => onContactSale?.(plan)}
                            className="px-6 py-3 rounded-lg text-sm font-bold focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all duration-300 shadow-lg bg-primary text-white hover:bg-primary-dark"
                          >
                            <div className="flex items-center space-x-2">
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                />
                              </svg>
                              <span>Contact Sale</span>
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-6">
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  No Upgrades Available
                </h3>
                <p className="text-gray-600 max-w-md mx-auto">
                  You&apos;re on our highest plan. No upgrade options are
                  available at the moment.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionUpgradeTab;
